module.exports = __webpack_public_path__ + "static/media/politicalEvent.ec58dbc2.svg";